import React from "react";
import { Skeleton } from "@mui/material";

const ClientCardSkeleton: React.FC = () => {
    return (
        <div className="w-full bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-100">
            <div className="flex items-center justify-between">
                <div className="flex flex-col justify-start items-start w-4/5">
                    <Skeleton width="33%" height={22} />
                    <Skeleton width="30%" height={7} />
                    <Skeleton width="30%" height={7} />
                </div>
                <div className="w-1/6 md:w-1/5 flex float-left md:block ">
                    <div className="relative ">
                        <div className="md:py-2 md:px-4">
                            <Skeleton
                                width="40%"
                                height={25}
                                variant="rounded"
                                sx={{
                                    borderRadius: "12px",
                                    width: {
                                        xs: "55%",
                                        md: "20%",
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientCardSkeleton;
